import React, { useEffect, useContext } from 'react'
import './App.css'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { setAuthToken, setIPAddress } from './product/common/api'
import { CookiesProvider } from 'react-cookie'
import AuthState from './product/context/auth/authState'
import CustomCommonState from './custom/context/common/commonState'
import VideoState from './product/context/video/videoState'
import ProductCommonState from './product/context/common/commonState'
import UserState from './product/context/user/userState'
import EmployeeState from './product/context/employee/empState'
import AlertState from './product/context/alert/alertState'
import CommunicationState from './product/context/communication/communicationState'
import CampaignState from './product/context/campaign/campaignState'
import MessageState from './product/context/message/messageState'
import BidDepositState from './product/context/bid_deposit/bidDepositState'
import TransactionState from './product/context/transaction/transactionState'
import CreditState from './product/context/credit/creditState'
import SettingState from './product/context/setting/settingState'
import ProductState from './product/context/product/productState'
import UserProductState from './product/context/userProduct/productState'
import UserBuyerState from './product/context/userBuyer/buyerState'
import UserCommonState from './product/context/userCommon/commonState'
import InvoiceState from './product/context/invoice/invoiceState'
import CartState from './product/context/cart/cartState'
import AgencyState from '@/product/context/agency/agencyState'
import LanguageManagerState from './product/context/languageManager/languageManagerState'
import ReportState from './product/context/report/reportState'
import SellerPayoutState from './product/context/sellerPayout/sellerPayoutState'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {
    ThemeProvider,
    StyledEngineProvider,
    createTheme,
} from '@mui/material/styles'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { SnackbarProvider } from 'notistack'
import Alerts from './product/common/alert'
import { publicIpv4 } from 'public-ip'
import AuctionState from './product/context/auction/auctionState'
import ReturnState from './product/context/return/returnState'
import BidState from './product/context/bid/bidState'
import DynamicState from './product/context/dynamic/dynamicState'
import AppointmentState from '@/product/context/appointment/appointmentState'
import AsinState from './product/context/thirdParty/asin/asinState'
import AppSheetState from './product/context/thirdParty/appsheet/appsheetState'
import HeadAlert from './custom/components/molecules/HeadAlert'
import ShipStationState from './product/context/thirdParty/shipping/shipStation/shipStationState'
import ControlHubState from './product/context/controlHub/controlHubState'
import InitialFunction from './product/views/InitialFunction'
import HomeState from './product/context/thirdParty/homeDepot/homeState'
import CommentState from '@/product/context/comment/commentState'
import TemplateProductState from './product/context/template/product/productState'
import TemplateAuctionState from './product/context/template/auction/auctionState'
import TwofactorState from './product/context/twoFactor/twofactorState'
import { theme } from './utils/UI/theme'
import StripeCardState from './product/context/stripe/card/cardState'
import StripeCustomerState from './product/context/stripe/customer/customerState'
import { GlobalStyles } from '@mui/material'
import ManifestState from './product/context/manifest/manifestState'
import ScheduledPickupState from './product/context/scheduledPickup/scheduledPickupState'
import PayState from '@/product/context/payment/payState'
import CouponState from './product/context/coupon/couponState'
import GiftState from './product/context/giftCard/giftState'
import ReturnCustomState from './custom/context/return/returnState'
import ProductCustomState from './custom/context/product/productState'
import SellerState from '@/product/context/stripe/seller/sellerState'
import CustomReportState from '@/custom/context/report/reportState'
import NewsState from '@/product/context/news/newsState'
global.site_url = process.env.REACT_APP_DOMAIN
global.controlhub_url = process.env.REACT_APP_API_CORE
global.images_url = global.site_url + '/uploads/product/'
global.site_id = process.env.REACT_SITE_ID
global.site_type = process.env.REACT_SITE_TYPE
global.enableDataGrid = true

global.homeDepot = true
global.showasin = true
global.ignoreStates = []
global.ignoreCountry = []
global.defaultCountry = 'US'
global.standalone = true
global.advFilters = true
global.auction_showInvoice = true
global.enableEditTableCell = true
global.enableColumnEdit = true
global.additionalFilter = true
global.showSelectValues = true
global.deleteIcon = true
global.barcode = true
global.qrcode = true
global.isCompress = true
global.viewStore = true
global.editLot = true
global.seller = true
global.listView = true
global.orderSort = true
global.hideCompactView = true
global.dynamicPermission = true
global.autoenable = true
global.noFullScreen = true
global.deactivated = true
global.invoiceTab = true
global.communication_templates = {
    editor: 'ckeditor4',
}
global.static_pages = {
    editor: 'ckeditor4',
}
global.tempAuct_tableActionString = ['removed', 'open']
global.templist_tableActionString = ['open', 'auction_assign']
global.listActionString = [
    'bidcount',
    'makeoffer',
    'questions',
    'date_closed',
    'return_notes',
]
global.erp_listAction = ['bidcount']
global.user_tableActionString = ['active', 'rejected', 'deactivate']
global.views = {
    invoice: {
        change_amount: true,
    },
}
global.bulk_ignoreFields = [
    'uploadimages',
    'wprice',
    'date_added',
    'date_closed',
    'buynow',
    'bprice',
    'location_id',
]
global.list_tableActionString = [
    'open',
    'auction_assign',
    'date_closed',
    'removed',
    'unsold',
]
global.auction_tableActionString = [
    'removed',
    'open',
    'closenow',
    'date_closed',
]
global.additionalBidHistory = [
    {
        field: 'custom_projects_internalId',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Internal ID',
    },
    {
        field: 'projects_id',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'ID',
    },
    {
        field: 'auctionlot_title',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Lot',
    },
    {
        field: 'projects_title',
        type: 'text',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Product',
    },

    {
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid',
    },
    // {
    //     field: 'buynow_qty',
    //     type: '',
    //     sort: true,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Quantity',
    // },
    {
        field: 'users_email',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Email',
    },

    // {
    //     field: 'bidtopstatus',
    //     type: 'text',
    //     sort: false,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Bid Status',
    // },
    {
        field: 'projects_market_status',
        type: 'capitalize',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Lot Status',
    },
    {
        field: 'projects_sprice',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Start Price',
    },
    {
        field: 'created_at',
        type: 'datetime',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid Date Time',
    },
]

// global.static_pages = {
//     editor: 'tinymce',
//     version: 'free',
// }

// global.communication_templates = {
//     editor: 'tinymce',
//     version: 'free',
// }

global.loadDashboardCount = true
global.customCategory = true
global.zb_session_timeout_ft = false
global.zb_custom_table_limit = 60
global.customDashboardFilter = {
    listing_custom_filter: {
        delete_status: {
            value: 'delete',
            type: 'notin',
            field: 'p.status',
        },
    },
    filterRange: true,
    search: 'within',
    within: 'month',
}

if (localStorage.token) {
    setAuthToken(localStorage.token)
}
const App = () => {
    useEffect(() => {
        async function fetchData() {
            const ipaddress = await publicIpv4()
            if (ipaddress) {
                setIPAddress(ipaddress)
            }
        }
        fetchData()
    }, [])

    return (
        <CookiesProvider>
            {/* <StyledEngineProvider injectFirst> */}
            <ThemeProvider theme={theme}>
                <CustomCommonState>
                    <StripeCardState>
                        <ProductCommonState>
                            <StripeCustomerState>
                                <PayState>
                                    <NewsState>
                                        <ReturnCustomState>
                                            <ProductCustomState>
                                                <SellerPayoutState>
                                                    <GiftState>
                                                        <CouponState>
                                                            <AuthState>
                                                                <AlertState>
                                                                    <UserState>
                                                                        <ManifestState>
                                                                            <CommentState>
                                                                                <AuctionState>
                                                                                    <ScheduledPickupState>
                                                                                        <ProductState>
                                                                                            <UserProductState>
                                                                                                <UserBuyerState>
                                                                                                    <UserCommonState>
                                                                                                        <InvoiceState>
                                                                                                            <CartState>
                                                                                                                <LanguageManagerState>
                                                                                                                    <EmployeeState>
                                                                                                                        <AgencyState>
                                                                                                                            <AppointmentState>
                                                                                                                                <ReportState>
                                                                                                                                    <CustomReportState>
                                                                                                                                        <BidDepositState>
                                                                                                                                            <TransactionState>
                                                                                                                                                <CommunicationState>
                                                                                                                                                    <CampaignState>
                                                                                                                                                        <HomeState>
                                                                                                                                                            <AsinState>
                                                                                                                                                                <AppSheetState>
                                                                                                                                                                    <MessageState>
                                                                                                                                                                        <TwofactorState>
                                                                                                                                                                            <SettingState>
                                                                                                                                                                                <VideoState>
                                                                                                                                                                                    <ReturnState>
                                                                                                                                                                                        <ControlHubState>
                                                                                                                                                                                            <SellerState>
                                                                                                                                                                                                <ShipStationState>
                                                                                                                                                                                                    <TemplateProductState>
                                                                                                                                                                                                        <TemplateAuctionState>
                                                                                                                                                                                                            <DynamicState>
                                                                                                                                                                                                                <BidState>
                                                                                                                                                                                                                    <CreditState>
                                                                                                                                                                                                                        <LocalizationProvider
                                                                                                                                                                                                                            dateAdapter={
                                                                                                                                                                                                                                AdapterMoment
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                        >
                                                                                                                                                                                                                            <SnackbarProvider
                                                                                                                                                                                                                                maxSnack={
                                                                                                                                                                                                                                    3
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                            >
                                                                                                                                                                                                                                <div className="App">
                                                                                                                                                                                                                                    <Alerts />
                                                                                                                                                                                                                                    <HeadAlert />
                                                                                                                                                                                                                                    <Router>
                                                                                                                                                                                                                                        <Routes />
                                                                                                                                                                                                                                    </Router>
                                                                                                                                                                                                                                </div>
                                                                                                                                                                                                                            </SnackbarProvider>
                                                                                                                                                                                                                        </LocalizationProvider>
                                                                                                                                                                                                                    </CreditState>
                                                                                                                                                                                                                </BidState>
                                                                                                                                                                                                            </DynamicState>
                                                                                                                                                                                                        </TemplateAuctionState>
                                                                                                                                                                                                    </TemplateProductState>
                                                                                                                                                                                                </ShipStationState>
                                                                                                                                                                                            </SellerState>
                                                                                                                                                                                        </ControlHubState>
                                                                                                                                                                                    </ReturnState>
                                                                                                                                                                                </VideoState>
                                                                                                                                                                            </SettingState>
                                                                                                                                                                        </TwofactorState>
                                                                                                                                                                    </MessageState>
                                                                                                                                                                </AppSheetState>
                                                                                                                                                            </AsinState>
                                                                                                                                                        </HomeState>
                                                                                                                                                    </CampaignState>
                                                                                                                                                </CommunicationState>
                                                                                                                                            </TransactionState>
                                                                                                                                        </BidDepositState>
                                                                                                                                    </CustomReportState>
                                                                                                                                </ReportState>
                                                                                                                            </AppointmentState>
                                                                                                                        </AgencyState>
                                                                                                                    </EmployeeState>
                                                                                                                </LanguageManagerState>
                                                                                                            </CartState>
                                                                                                        </InvoiceState>
                                                                                                    </UserCommonState>
                                                                                                </UserBuyerState>
                                                                                            </UserProductState>
                                                                                        </ProductState>
                                                                                    </ScheduledPickupState>
                                                                                </AuctionState>
                                                                            </CommentState>
                                                                        </ManifestState>
                                                                    </UserState>
                                                                </AlertState>
                                                            </AuthState>
                                                        </CouponState>
                                                    </GiftState>
                                                </SellerPayoutState>
                                            </ProductCustomState>
                                        </ReturnCustomState>
                                    </NewsState>
                                </PayState>
                            </StripeCustomerState>
                        </ProductCommonState>
                    </StripeCardState>
                </CustomCommonState>
            </ThemeProvider>
            {/* </StyledEngineProvider> */}
        </CookiesProvider>
    )
}

export default App
